import React, { useState } from "react";
import { Tabs } from "antd";
import { CompassOutlined, FileDoneOutlined } from "@ant-design/icons";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import JobOpeningsList from "./JobOpeningsList";
import MyApplicationsList from "./MyApplicationsList";

const ACCENT = "#0f5a2a";

function ExploreCareers() {
  const [activeTab, setActiveTab] = useState("openings");

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <div
            style={{
              background: "linear-gradient(135deg, #0f5a2a 0%, #1e8c45 100%)",
              borderRadius: "20px",
              padding: "22px 26px",
              color: "white",
              marginBottom: "18px",
              boxShadow: "0 8px 20px rgba(15,90,42,0.18)",
            }}
          >
            <div
              style={{
                fontSize: "0.72rem",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                opacity: 0.85,
                fontWeight: 600,
              }}
            >
              Internal Mobility
            </div>
            <div style={{ fontSize: "1.5rem", fontWeight: 600, marginTop: "4px" }}>
              Explore Careers
            </div>
            <div style={{ fontSize: "0.9rem", opacity: 0.95, marginTop: "6px" }}>
              Discover open roles tailored to your profile and track your applications in one place.
            </div>
          </div>

          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            tabBarStyle={{ marginBottom: 16 }}
            items={[
              {
                key: "openings",
                label: (
                  <span style={{ fontWeight: 600 }}>
                    <CompassOutlined style={{ marginRight: 6, color: ACCENT }} />
                    Job Openings
                  </span>
                ),
                children: <JobOpeningsList onApplied={() => setActiveTab("applications")} />,
              },
              {
                key: "applications",
                label: (
                  <span style={{ fontWeight: 600 }}>
                    <FileDoneOutlined style={{ marginRight: 6, color: ACCENT }} />
                    My Applications
                  </span>
                ),
                children: <MyApplicationsList />,
              },
            ]}
          />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default ExploreCareers;
